import axios, { AxiosResponse } from "axios";
import { AyudPeriodo } from "../interfaces/AYUDANTIAS/AyudPeriodo";
import { ResponseApi } from "../types/ResponseApi";
import { AyudanteInvInfo, voidSolicitudAyudanteInv } from "../interfaces/AYUDANTIAS/AyudanteInvInfo";
import { AyudantiaInvestigacion, AyudantiaInvestigacionData, PlanificacionAyudantia, ResponseAprobacion, solicitudAprobacionDTO, VoidAyudantiaInvestigacion, voidAyudantiaInvestigacionData } from "../interfaces/AYUDANTIAS/Ayudantia";
import { TblDecInvProyectoAyud, VoidTblDecInvProyectoAyud } from "../interfaces/AYUDANTIAS/TblDecInvProyectoAyud";
import { DatosGeneralesProyecto } from "../interfaces/AYUDANTIAS/DatosGenProyecto";

const localBack: string = process.env.REACT_APP_BACK || '';
//const localBack: string = 'http://192.168.253.6:8067';
const APICATALOGO: string = '/api/ConsultasInv';

const APICATALOGOPOST: string = '/api/TblSolicitudAyuds';
//const APIGESTIONAYUDANTIA: string = '/api/TblGestionSolicitudAyuds';

const APIGESTIONAYUDANTIA: string = '/api/GestionSolicitudes';


export default class AyudantiaService{
    async GetFechaAperturaCierreAyud(token: any, idperiodo : number): Promise<ResponseApi<AyudPeriodo>> {
        const response1: AxiosResponse<ResponseApi<AyudPeriodo>> = await axios.get(localBack + APICATALOGO + '/GetFechaAyudantiasInvestigacionByIdPeriodo/'+idperiodo,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

        //console.log(response1.data);
        return response1.data;
    }

    async ListSolicitudesAyudantiasByProyecto(token: any, idProyecto: number): Promise<ResponseApi<AyudanteInvInfo>> {
        try{

            const response1: AxiosResponse<ResponseApi<AyudanteInvInfo>> = await axios.get(`${localBack + APICATALOGO}/GetSolicitudesAyudantiasInvestigacionByIdProyecto/${idProyecto}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
            //console.log(response1.data);        
            return response1.data;

        }catch(error){
            console.error('Error al enviar la solicitud:', error);
            return {
                status: { isSuccessfully: false, messages: ['Error en la conexión a Api GetSolicitudesAyudantiasInvestigacionByIdProyectoyIdPeriodo '] },
                operation: 0,
                statusCode: 500,
                count: 0,
                listData: [],
                data: voidSolicitudAyudanteInv(),
            };
        }
    }

    async PostSolicitudAyudantiaInvById(token: any, data: AyudantiaInvestigacion): Promise<ResponseApi<AyudantiaInvestigacion>> {
        try {
            const response: AxiosResponse<ResponseApi<AyudantiaInvestigacion>> = await axios.post(`${localBack + APICATALOGOPOST}/PostSolicitudAyudantia`, data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
            return response.data;
        } catch (error : any) {
            
            return {
                status: { isSuccessfully: false, messages: [error?.response.data] },
                statusCode: 500,
                count: 0,
                operation: 0,
                data: VoidAyudantiaInvestigacion(),
                listData: []
            }
        }
    }

    // async GetSolicitudesAyudantiasByTipoPersonaEstado(token: any, tipoPersona: string, estado: string): Promise<ResponseApi<AyudantiaInvestigacionData>>{
    //     try{
    //         const response : AxiosResponse<ResponseApi<AyudantiaInvestigacionData>> = await axios.get(`${localBack + APICATALOGO}/GetSolicitudesAyudantiasInvestigacionByTipoPersona/${tipoPersona}&${estado}`,
    //             {
    //                 headers: {
    //                     Authorization: `Bearer ${token}`
    //                 }
    //             });

    //         return response.data;

    //     }catch(error : any){
    //         return {
    //             status: { isSuccessfully: false, messages: [error?.response.data] },
    //             statusCode: 500,
    //             count: 0,
    //             operation: 0,
    //             data: voidAyudantiaInvestigacionData(),
    //             listData: []
    //         }

    //     }
    // }

    async GetSolicitudesAyudantiasImpedimentoByTipoPersona(token: any, tipoPersona: string): Promise<ResponseApi<AyudantiaInvestigacionData>>{
        try{
            const response : AxiosResponse<ResponseApi<AyudantiaInvestigacionData>> = await axios.get(`${localBack + APICATALOGO}/GetSolicitudesAyudantiasInvestigacionConImpedimentosByTipoPersona/${tipoPersona}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

            return response.data;

        }catch(error : any){
            return {
                status: { isSuccessfully: false, messages: [error?.response.data] },
                statusCode: 500,
                count: 0,
                operation: 0,
                data: voidAyudantiaInvestigacionData(),
                listData: []
            }

        }
    }

    // async UpdateSolicitudAyudantiaInvById(token : any, data: AyudantiaInvestigacion) : Promise<ResponseApi<AyudantiaInvestigacion>>{
    //     try{
    //         const response : AxiosResponse<ResponseApi<AyudantiaInvestigacion>> = await axios.put(`${localBack + APICATALOGOPOST}/UpdateSolicitudAyudantiaInvestigacion`, data,
    //             {
    //                 headers:{
    //                     Authorization: `Bearer ${token}`
    //                 }
    //             })
    //         return response.data;

    //     }catch(error){
    //         return {
    //             status: { isSuccessfully: false, messages: ['Error en UpdateSolicitudAyudantiaInvById'] },
    //             statusCode: 500,
    //             count: 0,
    //             operation: 0,
    //             data: VoidAyudantiaInvestigacion(),
    //             listData: []
    //         }
    //     }
    // }

    async UpdateSolicitudAyudantiaInvById(token: any, data: TblDecInvProyectoAyud): Promise<ResponseApi<TblDecInvProyectoAyud>> {
        try {
            const response: AxiosResponse<ResponseApi<TblDecInvProyectoAyud>> = await axios.put(`${localBack + APICATALOGOPOST}/UpdateSolicitudAyudantiaInvestigacion/${data.iddecinvproyectoayud}`, data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
            return response.data;
        } catch (error) {
            //('error: ' + error);
            return {
                status: { isSuccessfully: false, messages: ['Error en UpdateSolicitudAyudantiaInvById'] },
                statusCode: 500,
                count: 0,
                operation: 0,
                data: VoidTblDecInvProyectoAyud(),
                listData: []
            }
        }
    }

    async GetSolicitudAyudantiaById(token: any, id: number): Promise<ResponseApi<AyudantiaInvestigacion>> {
        const response1: AxiosResponse<ResponseApi<AyudantiaInvestigacion>> = await axios.get(localBack + APICATALOGOPOST + '/GetSolicitudAyudantiaById/' + id,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
        return response1.data;
    }

    async DeleteSolicitudAyudantiaInvByIdDetalle(iddetallesol: number, token: any): Promise<ResponseApi<TblDecInvProyectoAyud>> {
        try {
          // var formData = new FormData();
          const response: AxiosResponse<ResponseApi<TblDecInvProyectoAyud>> = await axios.delete(
            localBack + APICATALOGOPOST + '/DeleteSolicitudAyudantia/' + iddetallesol,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          if (response.data) {
            let resp = response.data;
            //console.log(resp.strEstado);
            return resp;
          } else {
            throw new Error('No se recibieron datos válidos.');
          }
        } catch (error) {
          console.error('Error al enviar la solicitud:', error);
          throw error; // Re-lanzar el error para que se maneje donde se llama a la función
        }
    }

    // async PutAprobarSolicitudAyudantiaInv(token: any, idPersona: number, tipoPersona: string, data : AyudantiaInvestigacion): Promise<ResponseApi<AyudantiaInvestigacion>> {
    //     try {
    //         data.proyectoAyud.fechasolicitud = undefined;
    //         data.proyectoAyud.ultimoCambio = undefined;
    //         data.detalle.ultimoCambio = undefined;
    //         data.solicitudAyudCab.ultimoCambio = undefined;
    //         data.solicitudAyudCab.fechasolicitud = undefined;
            
    //         const response: AxiosResponse<ResponseApi<AyudantiaInvestigacion>> = await axios.put(`${localBack + APIGESTIONAYUDANTIA}/AprobarSolicitudAyudantia/${tipoPersona}&${idPersona}`, data,
    //             {
    //                 headers: {
    //                     Authorization: `Bearer ${token}`
    //                 }
    //             });
    //         return response.data;
    //     } catch (error : any) {
            
    //         return {
    //             status: { isSuccessfully: false, messages: [error?.response.data] },
    //             statusCode: 500,
    //             count: 0,
    //             operation: 0,
    //             data: VoidAyudantiaInvestigacion(),
    //             listData: []
    //         }
    //     }
    // }

    async AprobarSolicitudMultiple (token: any , data: Array<solicitudAprobacionDTO>, idPersona: number, tipoPersona: string){
        try{
            const response: AxiosResponse<ResponseApi<Array<ResponseAprobacion>>> = await axios.put(`${localBack+APIGESTIONAYUDANTIA}/AprobarSolicitudesAyudantias/${tipoPersona}&${idPersona}`,data,
                {
                    headers:{
                        Authorization: `Bearer ${token}`
                    }

                });
                return response.data;
        }catch(error: any){
            return {
                status: { isSuccessfully: false, messages: [error?.response.data] },
                statusCode: 500,
                count: 0,
                operation: 0,
                data: null,
                listData: Array<ResponseAprobacion>()
            }
        }
    
    }

    async RechazarSolicitudMultiple (token: any , data: Array<solicitudAprobacionDTO>, idPersona: number, tipoPersona: string){
        try{
            const response: AxiosResponse<ResponseApi<Array<solicitudAprobacionDTO>>> = await axios.put(`${localBack+APIGESTIONAYUDANTIA}/RechazarSolicitudesAyudantias/${tipoPersona}&${idPersona}`,data,
                {
                    headers:{
                        Authorization: `Bearer ${token}`
                    }

                });
                return response.data;
        }catch(error: any){
            return {
                status: { isSuccessfully: false, messages: [error?.response.data] },
                statusCode: 500,
                count: 0,
                operation: 0,
                data: null,
                listData: Array<solicitudAprobacionDTO>()
            }
        }
    
    }




    async GetDatosGeneralesProyecto(token: any, idProyecto: number): Promise<ResponseApi<DatosGeneralesProyecto>> {
        const response1: AxiosResponse<ResponseApi<DatosGeneralesProyecto>> = await axios.get(localBack + APICATALOGO + '/GetDatosGeneralesProyectoByIdProyecto/'+idProyecto,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

        return response1.data;
    }


    async GetSolicitudesAyudantiasPendientesByTipoPersona(token: any, tipoPersona: string): Promise<ResponseApi<AyudantiaInvestigacionData>>{
        try{
            const response : AxiosResponse<ResponseApi<AyudantiaInvestigacionData>> = await axios.get(`${localBack + APICATALOGO}/GetSolicitudesAyudantiasInvestigacionPendientesByTipoPersona/${tipoPersona}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

            return response.data;

        }catch(error : any){
            return {
                status: { isSuccessfully: false, messages: [error?.response.data] },
                statusCode: 500,
                count: 0,
                operation: 0,
                data: voidAyudantiaInvestigacionData(),
                listData: []
            }

        }
    }

    async GetSolicitudesAyudantiasAprobadasByTipoPersona(token: any, tipoPersona: string): Promise<ResponseApi<AyudantiaInvestigacionData>>{
        try{
            const response : AxiosResponse<ResponseApi<AyudantiaInvestigacionData>> = await axios.get(`${localBack + APICATALOGO}/GetSolicitudesAyudantiasInvestigacionAprobadasByTipoPersona/${tipoPersona}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

            return response.data;

        }catch(error : any){
            return {
                status: { isSuccessfully: false, messages: [error?.response.data] },
                statusCode: 500,
                count: 0,
                operation: 0,
                data: voidAyudantiaInvestigacionData(),
                listData: []
            }

        }
    }

    async GetSolicitudesAyudantiasRechazadasByTipoPersona(token: any, tipoPersona: string): Promise<ResponseApi<AyudantiaInvestigacionData>>{
        try{
            const response : AxiosResponse<ResponseApi<AyudantiaInvestigacionData>> = await axios.get(`${localBack + APICATALOGO}/GetSolicitudesAyudantiasInvestigacionNegadasByTipoPersona/${tipoPersona}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

            return response.data;

        }catch(error : any){
            return {
                status: { isSuccessfully: false, messages: [error?.response.data] },
                statusCode: 500,
                count: 0,
                operation: 0,
                data: voidAyudantiaInvestigacionData(),
                listData: []
            }

        }
    }

    async GetResumenAsignacionAyudantias(token: any): Promise<ResponseApi<PlanificacionAyudantia>> {
        const response1: AxiosResponse<ResponseApi<PlanificacionAyudantia>> = await axios.get(localBack + APICATALOGO + '/GetHorasAyudantiasInvestigacionAprobadas',
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

        //console.log(response1.data);
        return response1.data;
    }




}